import { createContext, useContext } from "react";

export const ScheduleWorkspaceContext = createContext({
  embedded: false,
  onClose: null,
  scheduleId: "",
  studyRow: null,
});

export function useScheduleWorkspace() {
  return useContext(ScheduleWorkspaceContext);
}
